<template>
  <div>
    <NewSendOut></NewSendOut>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const NewSendOut = defineAsyncComponent(() =>
  import("@/components/sendOuts/NewSendOut")
);
export default {
  components: {
    NewSendOut,
  },
};
</script>
